import { typographyCss, colors, cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { Spinner } from '@creditornot/cb-progress';
import React from 'react';
import Dropzone from 'react-dropzone';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type Props = {
  hasError?: boolean;
  fileName?: string;
  loading?: boolean;
  disabled?: boolean;
  onDrop: (files: File[]) => void;
};

const FileDrop = styled.div<{ error?: boolean }>`
  ${typographyCss.Body3()};
  width: 100%;
  padding: 24px 12px;
  border: 2px dashed ${({ error }) => (error ? colors.strawberry100 : cbSemanticCssVars.borderPrimary)};
  border-radius: 8px;
  text-align: center;
  outline: none;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const FileSelectLink = styled(T.Body3)`
  cursor: pointer;
  font-weight: 500;
  color: ${colors.wolt100};
`;

export const XmenuJsonDropzone = ({ hasError, fileName, loading, disabled, onDrop }: Props) => {
  return (
    <Dropzone onDrop={onDrop} disabled={disabled} useFsAccessApi={false}>
      {({ getRootProps, getInputProps, isDragActive }) => (
        <FileDrop {...getRootProps()} error={hasError}>
          <input {...getInputProps()} />
          {isDragActive ? (
            <FormattedMessage id="listing-manager.selections.venue-editor.xmenu-import.select-xmenu-file-drop" />
          ) : (
            <>
              {!fileName && (
                <FormattedMessage
                  id="listing-manager.selections.venue-editor.xmenu-import.select-xmenu-file"
                  values={{ action: chunks => <FileSelectLink>{chunks}</FileSelectLink> }}
                />
              )}
              {loading && <Spinner size="large" />}
              {!loading && fileName && <T.Body3>{fileName}</T.Body3>}
            </>
          )}
        </FileDrop>
      )}
    </Dropzone>
  );
};
